import ParameterLayerViewModel from '../viewmodels/ParameterLayerViewModel';
import WapiForecastParameterViewModel from '../viewmodels/WapiForecastParameterViewModel';

export function toParameterLayersViewModel(parameters, domainParameters) {
  const parameterLayers = [];
  let index = 0;
  parameters.forEach(x => {
    let parameterLayer = parameterLayers.find(pl => pl.level_type == x.level_type && pl.level == x.level)
    if (!parameterLayer) {
      parameterLayer = new ParameterLayerViewModel();
      parameterLayer.level_type = x.level_type;
      parameterLayer.level = x.level;
      parameterLayer.id = index++;
      parameterLayers.push(parameterLayer);
    }

    const wapiForecastParameterViewModel = new WapiForecastParameterViewModel().map(x);
    wapiForecastParameterViewModel.checked = domainParameters.includes(x.sname);

    parameterLayer.parameters.push(wapiForecastParameterViewModel);
  });

  return parameterLayers;
}
